/* eslint-disable no-console */
import { getEnv } from "../env";
const {
  REACT_APP_SEGMENT_API_KEY,
  REACT_APP_DISABLE_SEGMENT,
  NODE_ENV,
  STACK,
} = getEnv();
/**
 * Segment API Keys
 *
 * These are client-side keys, so they are safe to include in Javascript we send to customers.
 */
const SEGMENT_API_KEYS = Object.freeze({
  PlanGrid: "PjvY5z1pE4r99nH29k0Bh8Hj0QuxXZDD",
  PlanGridDevTest: "65z751kouu",
  GoldenGate: "KmsphFvKHKQEkgcdP2WaewtzyYPWY4vI",
  GoldenGateDevTest: "0eY6ZjxyHlN0Zf0aPgCLDJ1RKo2nch3g",
});
/**
 * Returns the correct Segment API key for the given environment, or null if Segment should not be loaded.
 */
export default function segmentApiKey() {
  if (REACT_APP_DISABLE_SEGMENT === "true") return null;
  // if REACT_APP_SEGMENT_API_KEY is set to a non-empty string, always use that.
  if (
    typeof REACT_APP_SEGMENT_API_KEY === "string" &&
    REACT_APP_SEGMENT_API_KEY.length > 0
  )
    return REACT_APP_SEGMENT_API_KEY;
  if (NODE_ENV !== "production" || STACK === "local") return null;
  if (STACK === "prod-gg") {
    return SEGMENT_API_KEYS.GoldenGate;
  } else if (STACK === "prod") {
    return SEGMENT_API_KEYS.PlanGrid;
  } else if (STACK === "test-gg" || STACK === "dev-gg") {
    return SEGMENT_API_KEYS.GoldenGateDevTest;
  } else if (STACK === "test" || STACK === "dev") {
    return SEGMENT_API_KEYS.PlanGridDevTest;
  } else {
    const reason =
      typeof STACK === "string"
        ? `process.env.STACK set to '${STACK}', which is unsupported`
        : "process.env.STACK isn't set";
    console.warn(`Segment not loaded because ${reason}.`);
  }
  return null;
}
